export const TITULO_PAGINA = 'Trocar forma de pagamento'

export const DESCRICAO_PAGINA_PARAGRAFO_1 = 'Você pode efetuar o pagamento com seu cartão de crédito.'

export const descricaoCobrancaMensal = valor => `A cobrança passa a ser mensal, no valor de ${valor} por mês.`

export const TITULO_MODAL_CONFIRMACAO = 'Deseja trocar a forma de pagamento?'

export const DESCRICAO_MODAL_CONFIRMACAO = 'Ao clicar em confirmar, a cobrança passará a ser feita no cartão de crédito cadastrado.'
